import client from "~/apis/client"

export function fetchPropertyNotes(from, to) {
  return client.get("/property_notes", { params: { from, to } })
}

export function createPropertyNote({ propertyId, onDate, body }) {
  return client.post("/property_notes", { property_id: propertyId, on_date: onDate, body })
}

export function deletePropertyNote(id) {
  return client.delete(`/property_notes/${id}`)
}
